import logo from './logo.svg';
import Top from './Top';
import img from './profile.jpg';
import Main from './Main';
import Footer from './Footer';

import './App.css';

function App() {
  return (
  <div>
   
    <Top />
    <Main />
    <Footer />
  </div>
    )
}

export default App;
